// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 792 ? "main" : chunkId) + "." + {"298":"7d641108","792":"932e5c7a","973":"d7c91ab9"}[chunkId] + ".css";
};